import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import {
  ADD_BILLING_RULE_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import Strings from "../../../../../resources/Strings";
import classes from "../WizardForm.module.css";
import {
  arrayNotEmpty,
  getErrorMessage,
  isRequired,
} from "../../../../../utils/FormUtils";
import TimePickerInput from "../../../Inputs/CustomInputs/TimePickerInput";
import DaysToggleButtons from "../../../Buttons/CustomToggleButton/DaysToggleButtons/DaysToggleButtons";
import DraggableListInput from "../../../Inputs/CustomInputs/DraggableListInput";
import CustomTooltip from "../../../Tooltip/CustomTooltip/CustomTooltip";
import SitesSelectInput from "../../../Inputs/CustomInputs/SitesSelectInput";
import { convertCurrencyToSymbol } from "../../../../../utils/CommonUtils";



const AddBillingRuleStep = (props) => {
  const [errors, setErrors] = useState({});
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);

  // excludes sites with isBillingEnabled false from selection list
  const selectedSites = useSelector((state) => state.user.selectedSites?.filter(site => site?.isBillingEnabled));

  const [stepHeader, setStepHeader] = useState( new StepHeaderEntity(
    props.isEditMode
      ? Strings.STEPS_TITLES.EDIT_BILLING_RULE_MODAL_TITLE
      : Strings.STEPS_TITLES.ADD_BILLING_RULE_MODAL_TITLE,
    "",
    Icons.BILLING_RULE,
    null
  ));
  const handleChange = (newProp) => {
    props.setSelectedSite(newProp?.selectedSite);
  }

  // useEffect(() => {
  //   //props.setSelectedSite(selectedSites[0])
  // }, [selectedSites]);

  useEffect(() => {
    if (props.currentStep === ADD_BILLING_RULE_FORM_STEPS.ADD_BILLING_RULE) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);
  
  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);

  if (props.currentStep !== ADD_BILLING_RULE_FORM_STEPS.ADD_BILLING_RULE) {
    return null;
  }

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };
  
  const getUserTypeSelectionOptionsList = () => {
    return userTypes
    .filter((type) => type.siteId === props.selectedSite.id || type.siteId === null /* adds Transient */)
    .map((type) => new ListItem(type.id, type.type, type.id));
  };

  const handleUserTypeSelectionRender = (selected) => {
      let list = getUserTypeSelectionOptionsList();

      return selected.map((type) => {
        let selection = [];
         list?.forEach((item) => {
          if ( type === item?.value) selection.push(item?.label)  
        })
        return selection
      }).join(',')
  };

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.ADD_BILLING_RULE_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.ADD_BILLING_RULE_SUB_TITLE}
      </span>

      <div className={classes.fileds}>
        <SitesSelectInput
          label={Strings.INPUT_LABELS.FACILITY}
          id={INPUTS_PROPS.SELECTED_SITE}
          onChange={handleChange}
          list={selectedSites} // list={props.sitesList}
          sitesData={null} // added
          value={props.isEditMode ? props.selectedSite.id : (props.selectedSite?.id ? props.selectedSite.id : selectedSites?.length >  0 ? selectedSites[0].id : null) } 
          disabled={props.isEditMode}
        />
        <SelectInput
          multiple={true}
          optionIcon={Icons.CHECKBOX_CIRCLE}
          label={Strings.INPUT_LABELS.BILLING_USER_TYPE}
          renderValue={handleUserTypeSelectionRender}
          list={getUserTypeSelectionOptionsList()}
          id={INPUTS_PROPS.BILLING_USER_TYPE}
          value={props.userType}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!arrayNotEmpty(props.userType).isValid}
          errorMessage={getErrorMessage(arrayNotEmpty(props.userType))}
        />
        <TextInput
          label={Strings.INPUT_LABELS.RULE_NAME}
          id={INPUTS_PROPS.RULE_NAME}
          value={props.ruleName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isRequired(props.ruleName).isValid}
          errorMessage={getErrorMessage(isRequired(props.ruleName))}
        />
        <div className={classes.subTitle}>Valid Days</div>
        <DaysToggleButtons
          value={props.days}
          onChange={props.handleChange}
          id={INPUTS_PROPS.DAYS}
          handleError={handleError}
          hasError={!arrayNotEmpty(props.days).isValid}
          errorMessage={getErrorMessage(arrayNotEmpty(props.days))}
          isStepSubmitted={props.isStepSubmitted}
        />

        <div className={classes.subTitle}>Valid Hours</div>
        <div className={classes.validHours}>
          <TimePickerInput
            label={Strings.INPUT_LABELS.RULE_START_TIME}
            id={INPUTS_PROPS.START_TIME}
            value={props.startTime}
            onChange={props.handleTimeChange}
            isStepSubmitted={props.isStepSubmitted}
            handleError={handleError}
            hasError={!isRequired(props.startTime).isValid}
            errorMessage={getErrorMessage(isRequired(props.startTime))}
          />
          <TimePickerInput
            label={Strings.INPUT_LABELS.RULE_FINISH_TIME}
            id={INPUTS_PROPS.END_TIME}
            value={props.endTime}
            onChange={props.handleTimeChange}
            isStepSubmitted={props.isStepSubmitted}
            handleError={handleError}
            hasError={!isRequired(props.endTime).isValid}
            errorMessage={getErrorMessage(isRequired(props.endTime))}
          />
        </div>

        {/* <div className={classes.stepTitle}>

          <CustomTooltip 
          title={""} 
          tooltipTitle={Strings.TOOLTIP_INFO_TITLE.ADD_RATE_LINE} 
          tooltipText={Strings.TOOLTIP_INFO_TEXT.ADD_RATE_LINE}  
          iconPath={Icons.INFO_CIRCLE}></CustomTooltip>
        </div> */}

        <div className={classes.infoTooltip}>
          <CustomTooltip 
          title={""} 
          tooltipTitle={Strings.TOOLTIP_INFO_TITLE.CREATE_BILLING_RULE} 
          tooltipText={Strings.TOOLTIP_INFO_TEXT.CREATE_BILLING_RULE}  
          iconPath={Icons.INFO_CIRCLE}>
          </CustomTooltip>
        </div>

        <DraggableListInput
          id={INPUTS_PROPS.RATES}
          items={props.rates}
          onChange={props.handleChange}
          handleDeleteRate={props.handleDeleteRate}
          currency={convertCurrencyToSymbol(props.selectedSite?.billingCurrency)}
        />
      </div>
      
      
      <button 
          disabled={props.isRuleDurationFilled}
          onClick={props.next}
          type="button"
          className={classes.addRateButton}
        >
          <span>{Strings.ADD_RATE_BUTTON}</span>
      </button>
      
    </div>
  );
};

export default AddBillingRuleStep;
